import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';

@Injectable({
    providedIn: 'root',
})
export class ClientModulesService {
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getDTUrl = this.basePath + environment.interop.clients.modules.getClientModulesDT;
    private storeUrl = this.basePath + environment.interop.clients.modules.storeClientModule;
    private deleteUrl = this.basePath + environment.interop.clients.modules.deleteClientModule;
    private getByClientId = this.basePath + environment.interop.clients.modules.getClientModulesByClient;
    private changeStatusActiveUrl = this.basePath + environment.interop.clients.modules.changeStatusContactActive;
    private getClientModuleByIdUrl = this.basePath + environment.interop.clients.modules.getClientModuleById;
    private updateClientModuleUrl = this.basePath + environment.interop.clients.modules.updateClientModule;
    private getUserClientModulesUrl = this.basePath + environment.interop.clients.modules.getUserClientModules;
    private updateOrderUrl = this.basePath + environment.interop.clients.modules.updateOrder

    constructor(private http: HttpClient) { }

    getClientModulesDT(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(this.getDTUrl, dataTablesParameters)
    }

    getUserClientModules() {
        return this.http.get(this.getUserClientModulesUrl);
    }

    getClientModulesByClient(clientId: number) {
        return this.http.get(this.getByClientId + clientId);
    }

    getClientModuleById(clientModuleId: number) {
        return this.http.get(`${this.getClientModuleByIdUrl}${clientModuleId}`);
    }

    addClientModule(data: any) {
        return this.http.post(this.storeUrl, data);
    }

    updateClientModule(data: any) {
        return this.http.put(this.updateClientModuleUrl, data);
    }

    deleteClientModule(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {});
    }

    updateOrder(id: number, data: any) {
        return this.http.put(this.updateOrderUrl + id, data, this.httpOptions);
    }
}
